import React, { useState, useRef } from 'react';
import { supabase } from '../supabase';
import Header from '../components/Header';
import PacchettoCardDemo from '../components/PacchettoCardDemo';
import PacchettoCardBarcelona from '../components/PacchettoCardBarcelona';
import PacchettoCardParigi from '../components/PacchettoCardParigi';

const C = {
  trasporto: '#EB1C24',
  alloggio: '#0071BA',
  attivita: '#FF5B00',
  servizi: '#009045',
  dark: '#0a1628',
  white: '#ffffff',
  text: '#1a1a2e',
  textLight: '#6b7280',
  border: '#e5e7eb',
  light: '#f5f7fa',
};

const SEGMENTI_HERO = {
  trasporto: '/images/trasporto.png',
  alloggio: '/images/alloggio.png',
  attivita: '/images/attivita.png',
  servizi: '/images/servizi.png',
};

const SEGMENTI_CARD = {
  trasporto: '/images/trasporto_icona.png',
  alloggio: '/images/alloggio_icona.png',
  attivita: '/images/attivita_icona.png',
  servizi: '/images/servizi_icona.png',
};

const ESPERIENZE = [
  {
    id: 1,
    destinazione: 'MADRID',
    utente: 'Federico93',
    notti: 7,
    adulti: 2,
    prezzo: 800,
    segmenti: ['trasporto', 'alloggio', 'attivita', 'servizi'],
    trasporto: 'Volo diretto Verona → Madrid',
    alloggio: 'Hotel Plaza ****',
    attivita: 'Tour Bernabeu · Flamenco · Tapas',
    servizi: 'Transfer · Noleggio bici',
  },
  {
    id: 2,
    destinazione: 'BARCELLONA',
    utente: 'Anna90',
    notti: 5,
    adulti: 2,
    prezzo: 650,
    segmenti: ['trasporto', 'alloggio', 'attivita'],
    trasporto: 'Volo diretto Milano → Barcellona',
    alloggio: 'Hotel Arts ****',
    attivita: 'Sagrada Familia · Camp Nou · Tapas',
    servizi: null,
  },
  {
    id: 3,
    destinazione: 'AMSTERDAM',
    utente: 'MarioRossi',
    notti: 4,
    adulti: 1,
    prezzo: 420,
    segmenti: ['alloggio', 'attivita'],
    trasporto: null,
    alloggio: 'B&B Canal View',
    attivita: 'Musei · Giro in barca · Mercati',
    servizi: null,
  },
];

function Card({ exp }) {
  return (
    <div style={cs.wrapper}>
      <div style={cs.anteprima}>ANTEPRIMA</div>
      <div style={cs.card}>
        <div style={cs.header}>
          <div style={cs.headerLeft}>
            <div style={cs.dest}>{exp.destinazione}</div>
            <div style={cs.meta}>{exp.notti} notti · {exp.adulti} {exp.adulti === 1 ? 'adulto' : 'adulti'}</div>
          </div>
          <div style={cs.prezzoBox}>
            <div style={cs.prezzoLabel}>spesa indicativa</div>
            <div style={cs.prezzoVal}>€ {exp.prezzo.toLocaleString('it-IT')}</div>
          </div>
        </div>
        <div style={cs.segmenti}>
          {['trasporto', 'alloggio', 'attivita', 'servizi'].map(key => {
            if (!exp[key]) return null;
            return (
              <div key={key} style={{ ...cs.segmento, borderLeft: `3px solid ${C[key]}` }}>
                <img src={SEGMENTI_CARD[key]} alt={key} style={cs.segIcon} />
                <span style={cs.segTesto}>{exp[key]}</span>
              </div>
            );
          })}
        </div>
        <div style={cs.footer}>
          <span style={cs.utente}>@{exp.utente}</span>
          <div style={cs.dots}>
            {exp.segmenti.map(s => (
              <span key={s} style={{ ...cs.dot, backgroundColor: C[s] }} />
            ))}
          </div>
          <button style={cs.btn}>Copia / Modifica</button>
        </div>
      </div>
      <div style={cs.vediDettaglio}>
        <a href="/bacheca" style={cs.vediLink}>Vedi dettaglio →</a>
      </div>
    </div>
  );
}

export default function Landing() {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [inviato, setInviato] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchDest, setSearchDest] = useState('');
  const [searchUtente, setSearchUtente] = useState('');
  const [cardIdx, setCardIdx] = useState(0);
  const touchStartX = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase
      .from('early_adopters')
      .insert([{ email, nome, fonte: 'landing' }]);
    if (!error) setInviato(true);
    setLoading(false);
  };

  return (
    <div style={s.page}>
      <style>{`
        @font-face { font-family: 'Roboto'; src: url('/fonts/Roboto-Regular.ttf'); font-weight: 400; }
        @font-face { font-family: 'Roboto'; src: url('/fonts/Roboto-Medium.ttf'); font-weight: 500; }
        @font-face { font-family: 'Roboto'; src: url('/fonts/Roboto-Bold.ttf'); font-weight: 700; }
        @font-face { font-family: 'Roboto'; src: url('/fonts/Roboto-Black.ttf'); font-weight: 900; }
        * { font-family: 'Roboto', sans-serif; box-sizing: border-box; margin: 0; padding: 0; }
        a { text-decoration: none; }
        button:hover { opacity: 0.85; }
        .octa-hamburger { display: none; }
        @media (max-width: 1024px) {
          .octa-header { padding: 12px 32px !important; }
          .octa-hero { padding: 60px 32px 48px !important; }
          .octa-hero-title { font-size: 40px !important; line-height: 1.2 !important; }
          .octa-section { padding: 56px 32px !important; }
          .octa-footer { padding: 24px 32px !important; }
        }
        .octa-seg-pill {
          display: inline-flex; align-items: center; justify-content: center; gap: 10px;
          padding: 10px 22px; border-radius: 8px; border: 2px solid transparent;
          font-weight: 800; font-size: 16px; font-style: italic; letter-spacing: 0.04em;
          transition: background 0.2s, color 0.2s, border-color 0.2s;
          color: white; text-decoration: none; cursor: pointer;
          min-width: 180px;
        }
        .octa-seg-pill img { height: 22px; filter: brightness(0) invert(1); transition: filter 0.2s; }
        .octa-seg-pill:hover img { filter: none; }
        .octa-seg-trasporto { background: #EB1C24; }
        .octa-seg-trasporto:hover { background: white; color: #EB1C24; border-color: #EB1C24; }
        .octa-seg-alloggio { background: #0071BA; }
        .octa-seg-alloggio:hover { background: white; color: #0071BA; border-color: #0071BA; }
        .octa-seg-attivita { background: #FF5B00; }
        .octa-seg-attivita:hover { background: white; color: #FF5B00; border-color: #FF5B00; }
        .octa-seg-servizi { background: #009045; }
        .octa-seg-servizi:hover { background: white; color: #009045; border-color: #009045; }
        .octa-carousel-arrow {
          position: absolute; top: 50%; transform: translateY(-50%);
          width: 48px; height: 48px; border-radius: 50%;
          background: white; border: 2px solid #e0e4ea;
          box-shadow: 0 2px 12px rgba(0,0,0,0.14);
          font-size: 30px; cursor: pointer; padding: 0;
          display: flex; align-items: center; justify-content: center;
          color: #0a1628; transition: background 0.2s, color 0.2s, box-shadow 0.2s;
          z-index: 20; line-height: 1;
        }
        .octa-carousel-arrow:hover { background: #0a1628 !important; color: white !important; border-color: #0a1628 !important; opacity: 1 !important; box-shadow: 0 4px 20px rgba(0,0,0,0.22) !important; }
        .octa-carousel-arrow-left { left: 6px; }
        .octa-carousel-arrow-right { right: 6px; }
        .octa-carousel-outer { position: relative; margin: 0 auto 40px; max-width: 880px; padding: 0 60px; }
        .octa-carousel-track-wrap { overflow: hidden; border-radius: 16px; zoom: 0.72; }
        @media (max-width: 700px) { .octa-carousel-arrow { display: none !important; } }
        @media (max-width: 640px) {
          .octa-carousel-outer { padding: 0; max-width: none; width: calc(100% + 40px); margin-left: -20px; margin-right: -20px; margin-bottom: 20px; }
          .octa-carousel-track-wrap { zoom: 1; border-radius: 0; }
        }
        @media (max-width: 640px) {
          .octa-hamburger { display: flex !important; align-items: center; }
          .octa-seg-row { flex-direction: column !important; align-items: center !important; gap: 12px !important; }
          .octa-nav-link { display: none !important; }
          .octa-header { padding: 12px 20px !important; }
          .octa-hero { padding: 48px 20px 40px !important; }
          .octa-hero-title { font-size: 34px !important; line-height: 1.2 !important; }
          .octa-section { padding: 40px 20px !important; }
          .octa-search-grid { flex-direction: column !important; }
          .octa-footer { padding: 24px 20px !important; flex-direction: column !important; align-items: flex-start !important; }
        }
      `}</style>

      <Header light bg={C.white} />

      {/* HERO */}
      <section style={s.hero} className="octa-hero">
        <div style={s.heroTag}>🗂 Vetrina di esperienze reali</div>
        <h1 style={s.heroTitle} className="octa-hero-title">Una vetrina di esperienze<br />che puoi copiare e personalizzare</h1>
        <p style={s.heroSub}>
          Cerca l'esperienza di un amico o in base alla destinazione, copiala e personalizzala.
        </p>

        {/* CAROUSEL PACCHETTI DEMO */}
        {(() => {
          const cards = [<PacchettoCardDemo />, <PacchettoCardBarcelona />, <PacchettoCardParigi />];
          return (
            <div className="octa-carousel-outer">
              {/* Track */}
              <div
                className="octa-carousel-track-wrap"
                onTouchStart={e => { touchStartX.current = e.touches[0].clientX; }}
                onTouchEnd={e => {
                  const delta = e.changedTouches[0].clientX - touchStartX.current;
                  if (delta < -50 && cardIdx < cards.length - 1) setCardIdx(i => i + 1);
                  if (delta > 50 && cardIdx > 0) setCardIdx(i => i - 1);
                }}
              >
                <div style={{ display: 'flex', transform: `translateX(-${cardIdx * 100}%)`, transition: 'transform 0.4s cubic-bezier(0.4,0,0.2,1)' }}>
                  {cards.map((card, i) => (
                    <a key={i} href="/demo" style={{ flex: '0 0 100%', minWidth: 0, display: 'block', textDecoration: 'none' }}>
                      <div
                        style={{ boxShadow: '0 4px 24px rgba(0,0,0,0.09)', border: `1px solid ${C.border}`, borderRadius: '16px', overflow: 'hidden', transition: 'box-shadow 0.2s' }}
                        onMouseEnter={e => e.currentTarget.style.boxShadow = '0 8px 40px rgba(0,0,0,0.16)'}
                        onMouseLeave={e => e.currentTarget.style.boxShadow = '0 4px 24px rgba(0,0,0,0.09)'}
                      >
                        {card}
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Frecce */}
              {cardIdx > 0 && (
                <button onClick={() => setCardIdx(i => i - 1)} className="octa-carousel-arrow octa-carousel-arrow-left" aria-label="Precedente">‹</button>
              )}
              {cardIdx < cards.length - 1 && (
                <button onClick={() => setCardIdx(i => i + 1)} className="octa-carousel-arrow octa-carousel-arrow-right" aria-label="Successivo">›</button>
              )}

              {/* Dots */}
              <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '12px' }}>
                {cards.map((_, i) => (
                  <button key={i} onClick={() => setCardIdx(i)} style={{
                    width: i === cardIdx ? '24px' : '8px', height: '8px',
                    borderRadius: '4px',
                    backgroundColor: i === cardIdx ? C.dark : C.border,
                    border: 'none', cursor: 'pointer', padding: 0,
                    transition: 'all 0.3s',
                  }} />
                ))}
              </div>
            </div>
          );
        })()}

      </section>

      {/* RICERCA MODULARE */}
      <section style={{ backgroundColor: C.light, padding: '64px 60px', borderBottom: `1px solid ${C.border}`, textAlign: 'center' }} className="octa-section">
        <div style={{ maxWidth: '700px', margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(22px, 3vw, 34px)', fontWeight: 900, color: C.text, marginBottom: '16px', lineHeight: 1.2 }}>
            Cerca e confronta in unico sito
          </h2>
          <p style={{ fontSize: '17px', color: C.textLight, marginBottom: '28px', lineHeight: 1.75 }}>
            OCTA si basa su una ricerca modulare, potrai visualizzare solo i risultati che ti interessano eliminando gli altri.
          </p>
          <p style={{ fontSize: '16px', color: C.text, lineHeight: 1.85, marginBottom: '0' }}>
            Costruisci il tuo viaggio come un puzzle, ogni pezzo è un segmento, decidi tu come costruirlo.
            Confronta tutti i mezzi di trasporto, tutte le tipologie di alloggio, le attività locali e i servizi di base,
            come abbonamenti, collegamenti, noleggi e molto altro.{' '}
            <span style={{ fontWeight: 900, fontSize: '18px' }}>Tutto, su unico sito.</span>
          </p>
        </div>
        {/* SEGMENTI — pill con hover invertito */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', flexWrap: 'nowrap', marginTop: '40px' }} className="octa-seg-row">
          {[
            { key: 'trasporto', label: 'TRASPORTO' },
            { key: 'alloggio',  label: 'ALLOGGIO'  },
            { key: 'attivita',  label: 'ATTIVITÀ'   },
            { key: 'servizi',   label: 'SERVIZI'    },
          ].map(({ key, label }) => (
            <a key={key} href={`/${key}`} className={`octa-seg-pill octa-seg-${key}`}>
              <img src={`/images/${key}_icona.png`} alt={label} />
              {label}
            </a>
          ))}
        </div>
      </section>

      {/* RICERCA */}
      <section style={s.searchSection} className="octa-section">
        <div style={s.searchGrid} className="octa-search-grid">
          <div style={s.searchBox}>
            <div style={s.searchTitle}>Cerca per nome utente</div>
            <div style={s.searchRow}>
              <span>🔍</span>
              <input type="text" placeholder="es. Federico93" value={searchUtente}
                onChange={e => setSearchUtente(e.target.value)} style={s.searchInput} />
            </div>
            <a href="/bacheca" style={s.searchBtn}>CERCA →</a>
          </div>
          <div style={{ ...s.searchBox, alignItems: 'center', textAlign: 'center' }}>
            <div style={s.searchTitle}>Non sai dove andare?</div>
            <a href="/bacheca" style={s.discoverBtn}>Scopri le proposte migliori</a>
          </div>
          <div style={s.searchBox}>
            <div style={s.searchTitle}>Sai dove vuoi andare?</div>
            <div style={s.searchRow}>
              <span>🔍</span>
              <input type="text" placeholder="es. Madrid, Amsterdam..." value={searchDest}
                onChange={e => setSearchDest(e.target.value)} style={s.searchInput} />
            </div>
            <a href="/bacheca" style={s.searchBtn}>CERCA →</a>
          </div>
        </div>
      </section>

      {/* ESPERIENZE */}
      <section style={s.esperienze} className="octa-section">
        <h2 style={s.sectionTitle}>Esperienze in evidenza</h2>
        <p style={s.sectionSub}>
          Ogni esperienza può avere uno o più segmenti — anche solo l'alloggio, o solo le attività. Scegli tu cosa cercare.
          Lasciati ispiare dalle esperienze dei tuoi amici!
        </p>
        <div style={s.cardsGrid}>
          {ESPERIENZE.map(exp => <Card key={exp.id} exp={exp} />)}
        </div>
        <div style={{ textAlign: 'center', marginTop: '12px', marginBottom: '32px', display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href="/demo" style={{ display: 'inline-block', padding: '12px 28px', backgroundColor: C.dark, color: C.white, borderRadius: '8px', fontWeight: 700, fontSize: '14px', textDecoration: 'none' }}>
            Vedi il pacchetto interattivo →
          </a>
          <a href="/bacheca" style={s.allBtn}>Vedi tutte le esperienze →</a>
        </div>
      </section>

      {/* COME FUNZIONA */}
      <section style={s.howSection} className="octa-section">
        <h2 style={{...s.sectionTitle, color: C.white}}>Come funziona</h2>
        <div style={s.steps}>
  {[
    { n: '1', color: C.trasporto, title: "Cerca un'esperienza", text: 'Cerca per destinazione, nome utente, o lasciati ispirare dalle esperienze più copiate.' },
    { n: '2', color: C.attivita, title: 'Copia e personalizza', text: "Prendi un'esperienza che ti piace, copiala e modificala secondo le tue esigenze." },
    { n: '3', color: C.servizi, title: 'Salva e condividi', text: 'Salva il tuo viaggio, condividilo con amici o rendilo pubblico per ispirare altri.' },
  ].map(step => (
    <div key={step.n} style={s.step}>
      <div style={s.stepHeader}>
        <div style={{ ...s.stepNum, backgroundColor: step.color }}>{step.n}</div>
        <h3 style={s.stepTitle}>{step.title}</h3>
      </div>
      <p style={s.stepText}>{step.text}</p>
    </div>
          ))}
        </div>
      </section>

      {/* COMING SOON */}
      <section style={s.comingSection} className="octa-section">
        <div style={s.comingBox}>
          <div style={s.comingTag}>🚀 Prossimamente</div>
          <h2 style={s.comingTitle}>La piattaforma completa sta arrivando</h2>
          <p style={s.comingText}>
            Nella versione futura potrai cercare in tempo reale tutti i voli, treni, bus e bici,
            comparare migliaia di alloggi, scoprire attività locali e aggiungere servizi come
            transfer, noleggi e biglietti — tutto in un unico flusso.
          </p>
          <div style={s.comingList}>
            {[
              { key: 'trasporto', label: 'Voli · Treni · Bus · Auto · Bici' },
              { key: 'alloggio', label: 'Hotel · B&B · Appartamenti' },
              { key: 'attivita', label: 'Tour · Esperienze · Cultura' },
              { key: 'servizi', label: 'Transfer · Noleggi · Biglietti' },
            ].map(item => (
              <a key={item.key} href={`/${item.key}`} style={{ textDecoration: 'none' }}>
                <div style={{ ...s.comingItem, borderLeft: `4px solid ${C[item.key]}`, cursor: 'pointer', transition: 'opacity 0.15s' }} onMouseEnter={e => e.currentTarget.style.opacity='0.75'} onMouseLeave={e => e.currentTarget.style.opacity='1'}>
                  <img src={SEGMENTI_HERO[item.key]} alt={item.key} style={s.comingIcon} />
                  <span style={s.comingLabel}>{item.label}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* EARLY ADOPTERS */}
      <section style={s.earlySection} className="octa-section">
        <div style={s.earlyBox}>
          <h2 style={s.earlyTitle}>Sii tra i primi ad accedere</h2>
          <p style={s.earlySub}>
            Lascia la tua email — ti avvisiamo quando OCTA apre al pubblico
            e avrai accesso prioritario alla piattaforma completa.
          </p>
          {!inviato ? (
            <form onSubmit={handleSubmit} style={s.form}>
              <input type="text" placeholder="Il tuo nome" value={nome}
                onChange={e => setNome(e.target.value)} style={s.input} required />
              <input type="email" placeholder="La tua email" value={email}
                onChange={e => setEmail(e.target.value)} style={s.input} required />
              <button type="submit" style={s.submitBtn} disabled={loading}>
                {loading ? 'Invio...' : 'Voglio accedere prima degli altri →'}
              </button>
            </form>
          ) : (
            <div style={s.successMsg}>
              🎉 Perfetto! Ti contatteremo presto. Benvenuto nella community OCTA!
            </div>
          )}
        </div>
      </section>

      {/* FOOTER */}
      <footer style={s.footer} className="octa-footer">
        <img src="/images/logo_bianco.png" alt="OCTA" style={s.footerLogo} />
        <p style={s.footerText}>© 2025 OCTA — Online Complete Travel Agency</p>
        <div style={s.footerDots}>
          {['trasporto', 'alloggio', 'attivita', 'servizi'].map(k => (
            <span key={k} style={{ ...s.footerDot, backgroundColor: C[k] }} />
          ))}
        </div>
      </footer>

    </div>
  );
}

const s = {
  page: { backgroundColor: C.light, minHeight: '100vh', color: C.text },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 60px', backgroundColor: C.white, position: 'sticky', top: 0, zIndex: 100, borderBottom: `1px solid ${C.border}` },
  logo: { height: '36px', objectFit: 'contain' },
  headerBtns: { display: 'flex', alignItems: 'center', gap: '28px' },
  navLink: { color: C.text, fontSize: '14px', fontWeight: 500, textDecoration: 'none' },
  loginBtn: { padding: '10px 24px', borderRadius: '8px', backgroundColor: C.alloggio, color: C.white, fontSize: '14px', fontWeight: 700, textDecoration: 'none' },
  hero: { backgroundColor: C.white, padding: '80px 60px 60px', textAlign: 'center', borderBottom: `1px solid ${C.border}` },
  heroTag: { display: 'inline-block', padding: '6px 16px', backgroundColor: '#e8f4fd', color: C.alloggio, borderRadius: '50px', fontSize: '13px', fontWeight: 600, marginBottom: '24px' },
  heroTitle: { fontSize: 'clamp(30px, 5vw, 52px)', fontWeight: 900, lineHeight: 1.15, marginBottom: '20px', color: C.text },
  heroSub: { fontSize: 'clamp(15px, 2vw, 18px)', color: C.textLight, lineHeight: 1.7, maxWidth: '680px', margin: '0 auto 44px' },
  segmentiRow: { display: 'flex', justifyContent: 'center', gap: '16px', flexWrap: 'wrap' },
  segHeroImg: { height: '44px', objectFit: 'contain', borderRadius: '8px' },
  searchSection: { backgroundColor: C.white, padding: '48px 60px', borderBottom: `1px solid ${C.border}` },
  searchGrid: { display: 'flex', gap: '32px', maxWidth: '1100px', margin: '0 auto', flexWrap: 'wrap' },
  searchBox: { flex: 1, minWidth: '260px', display: 'flex', flexDirection: 'column', gap: '12px' },
  searchTitle: { fontSize: '15px', fontWeight: 700, color: C.text },
  searchRow: { display: 'flex', alignItems: 'center', gap: '8px', border: `1px solid ${C.border}`, borderRadius: '4px', padding: '10px 14px', backgroundColor: '#fafafa' },
  searchInput: { border: 'none', background: 'transparent', fontSize: '14px', color: C.text, width: '100%', outline: 'none' },
  searchBtn: { display: 'inline-block', padding: '10px 20px', backgroundColor: C.dark, color: C.white, borderRadius: '8px', fontSize: '13px', fontWeight: 700, textAlign: 'center' },
  discoverBtn: { display: 'inline-block', padding: '14px 28px', backgroundColor: C.attivita, color: C.white, borderRadius: '50px', fontSize: '15px', fontWeight: 700, marginTop: '8px' },
  esperienze: { padding: '80px 60px', maxWidth: '1200px', margin: '0 auto' },
  sectionTitle: { fontSize: 'clamp(22px, 3.5vw, 32px)', fontWeight: 900, marginBottom: '12px', color: C.text },
  sectionSub: { fontSize: '15px', color: C.textLight, marginBottom: '40px' },
  cardsGrid: { display: 'flex', gap: '24px', flexWrap: 'wrap', marginBottom: '48px' },
 previewBox: { maxWidth: '500px', margin: '0 auto 48px', borderRadius: '16px', overflow: 'hidden', border: `1px solid ${C.border}`, boxShadow: '0 4px 24px rgba(0,0,0,0.10)' },
  previewImg: { width: '100%', display: 'block' },
  allBtn: { display: 'inline-block', padding: '12px 28px', border: `2px solid ${C.alloggio}`, color: C.alloggio, borderRadius: '8px', fontWeight: 700, fontSize: '14px' },
  howSection: { backgroundColor: C.dark, padding: '80px 60px', borderTop: `1px solid ${C.border}` },
  steps: { display: 'flex', gap: '32px', maxWidth: '1000px', margin: '40px auto 0', flexWrap: 'wrap', alignItems: 'flex-start' },
step: { flex: 1, padding: '32px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '16px', border: '1px solid rgba(255,255,255,0.1)', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  stepNum: { width: '44px', height: '44px', borderRadius: '50%', color: C.white, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 900, flexShrink: 0 },
stepHeader: { display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '16px', width: '100%', justifyContent: 'center' },
stepTitle: { fontSize: '18px', fontWeight: 700, color: C.white },
stepText: { fontSize: '14px', color: 'rgba(255,255,255,0.6)', lineHeight: 1.6, textAlign: 'center', width: '100%' },
  comingSection: { padding: '80px 60px', display: 'flex', justifyContent: 'center' },
  comingBox: { maxWidth: '760px', width: '100%', backgroundColor: C.dark, borderRadius: '24px', padding: '60px', color: C.white },
  comingTag: { display: 'inline-block', padding: '6px 16px', backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: '50px', fontSize: '13px', fontWeight: 600, marginBottom: '20px' },
  comingTitle: { fontSize: '32px', fontWeight: 900, marginBottom: '16px' },
  comingText: { fontSize: '16px', color: 'rgba(255,255,255,0.7)', lineHeight: 1.7, marginBottom: '32px' },
  comingList: { display: 'flex', flexDirection: 'column', gap: '12px' },
  comingItem: { padding: '14px 20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '16px' },
  comingIcon: { height: '28px', objectFit: 'contain', borderRadius: '4px' },
  comingLabel: { fontSize: '14px', color: 'rgba(255,255,255,0.7)', fontWeight: 500 },
  earlySection: { padding: '80px 60px', display: 'flex', justifyContent: 'center', backgroundColor: C.white, borderTop: `1px solid ${C.border}` },
  earlyBox: { maxWidth: '560px', width: '100%', textAlign: 'center' },
  earlyTitle: { fontSize: '32px', fontWeight: 900, marginBottom: '12px' },
  earlySub: { fontSize: '15px', color: C.textLight, marginBottom: '36px', lineHeight: 1.6 },
  form: { display: 'flex', flexDirection: 'column', gap: '14px' },
  input: { padding: '14px 18px', borderRadius: '4px', border: `1px solid ${C.border}`, fontSize: '15px', backgroundColor: '#fafafa', outline: 'none' },
  submitBtn: { padding: '16px', borderRadius: '10px', backgroundColor: C.alloggio, color: C.white, fontSize: '15px', fontWeight: 700, border: 'none', cursor: 'pointer' },
  successMsg: { padding: '24px', backgroundColor: '#f0fdf4', borderRadius: '12px', border: '1px solid #bbf7d0', fontSize: '16px', color: '#166534' },
  footer: { padding: '32px 60px', borderTop: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', backgroundColor: C.dark, flexWrap: 'wrap', gap: '16px' },
  footerLogo: { height: '32px', objectFit: 'contain' },
  footerText: { fontSize: '13px', color: 'rgba(255,255,255,0.4)' },
  footerDots: { display: 'flex', gap: '8px' },
  footerDot: { width: '12px', height: '12px', borderRadius: '50%' },
};

const cs = {
  card: {card: { backgroundColor: C.white, borderRadius: '16px', border: `1px solid ${C.border}`, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },backgroundColor: C.white, borderRadius: '16px', border: `1px solid ${C.border}`, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  header: { backgroundColor: C.dark, color: C.white, padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  headerLeft: { flex: 1 },
  dest: { fontSize: '20px', fontWeight: 900, letterSpacing: '2px' },
  meta: { fontSize: '12px', color: 'rgba(255,255,255,0.6)', marginTop: '4px' },
  prezzoBox: { textAlign: 'right', flexShrink: 0 },
  prezzoLabel: { fontSize: '10px', color: 'rgba(255,255,255,0.5)' },
  prezzoVal: { fontSize: '18px', fontWeight: 900 },
  segmenti: { padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: '10px' },
  segmento: { paddingLeft: '12px', display: 'flex', flexDirection: 'column', gap: '4px' },
  segIcon: { height: '18px', objectFit: 'contain', objectPosition: 'left' },
  segTesto: { fontSize: '13px', color: C.textLight },
  footer: { padding: '14px 20px', borderTop: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  utente: { fontSize: '12px', color: C.textLight, fontWeight: 500 },
  dots: { display: 'flex', gap: '4px' },
  dot: { width: '8px', height: '8px', borderRadius: '50%' },
  btn: { padding: '7px 14px', backgroundColor: C.dark, color: C.white, border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 700, cursor: 'pointer' },
  wrapper: { flex: 1, minWidth: '280px', maxWidth: '380px', display: 'flex', flexDirection: 'column', gap: '8px' },
  anteprima: { fontSize: '11px', fontWeight: 700, letterSpacing: '2px', color: C.textLight, textTransform: 'uppercase', paddingLeft: '4px' },
  vediDettaglio: { textAlign: 'right', paddingRight: '4px' },
  vediLink: { fontSize: '13px', fontWeight: 600, color: C.alloggio },
};